import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	configEditor: {
		marginTop: '10vh',
		overflow: 'hidden',
		display: 'flex',
		width: '100%',
		height: '90vh',
		justifyContent: 'space-around !important',
		borderRadius: '5px',
		alignItems: 'center !important',
		backgroundImage: `linear-gradient(-45deg,${theme.palette.primary.lightOne},${theme.palette.secondary.grey},${theme.palette.primary.lightOne})`,
		backgroundSize: '200% 100%',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: '0% 50%',
		animation: '$gradientAnimation 20s infinite'
	},
	'@keyframes gradientAnimation': {
		'0%': {
			backgroundPosition: '0% 50%'
		},
		'50%': {
			backgroundPosition: '100% 50%'
		},
		'100%': {
			backgroundPosition: '0% 50%'
		}
	},

	sidebar: {
		position: 'relative',
		flex: 1.2,
		backgroundColor: 'white',
		color: theme.palette.primary.contrastText,
		overflowY: 'scroll',
		overflowX: 'hidden',
		height: '100%',
		paddingTop: '8rem',
		borderRight: '1px solid #909497',
		transition: 'all 0.2s ease !important',
		width: '40rem !important'
	},
	sidebarCollapsed: {
		flex: 0.18
	},
	sidebarCollapseIconContainer: {
		color: theme.palette.primary.main,
		position: 'absolute',
		top: '0',
		left: '1.5rem',
		padding: '2.5rem 2rem 0 .5rem',
		cursor: 'pointer',
		'& svg': {
			transition: 'all 0.2s ease-in-out'
		}
	},
	sidebarButtonContainer: {
		padding: '.5rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginTop: '3rem',
		transition: 'all .1s ease',
		visibility: 'visible',
		opacity: 1,
		height: '4rem !important',
		overflow: 'hidden'
	},
	sidebarButtonContainerHidden: {
		visibility: 'hidden',
		pointerEvents: 'none',
		opacity: 0
	},

	settingNameContainer: {
		display: 'flex',
		justifyContent: 'flex-start',
		width: '100%',
		color: theme.palette.primary.grey,
		cursor: ' pointer',
		minHeight: '4.8rem !important',
		overflow: 'hidden',
		paddingLeft: '.6rem',
		paddingTop: '.45rem',
		borderBottom: '2px solid #fff',
		marginTop: '1rem !important',
		transition: 'flex height .6s ease',
		alignItems: 'center',
		margin: 0
	},
	settingNameContainerCollapsed: {
		justifyContent: 'center',
		borderRadius: '0 5rem 5rem 0',
		width: '90%'
	},
	settingIconContainer: {
		flex: 1,
		marginTop: '.5rem',
		marginLeft: '1rem',
		marginRight: '1.5rem',
		transition: 'all .6s ease'
	},
	settingIconContainerCollapsed: {},
	settingName: {
		flex: 9,
		width: '100%',
		overflow: 'hidden',
		animation: '$fadeInAnimation .4s'
	},
	'@keyframes fadeInAnimation': {
		'0%': {
			opacity: 0,
			transform: 'translateX(-20px)'
		},

		'100%': {
			opacity: 1,
			transform: 'translateX(0)'
		}
	},
	settingSelected: {
		backgroundColor: theme.palette.primary.lightOne + ' !important',
		color: theme.palette.primary.main + ' !important'
	},

	settingConfig: {
		flex: 4.5,
		height: '94%',
		overflowY: 'scroll'
	},

	accordionStyle: {
		boxShadow: 'unset !important',
		position: 'initial !important',
		padding: '0px !important',
		marginTop: '1rem !important',
		'& div': {
			margin: '0 !important'
		},
		'& > div': {
			color: theme.palette.primary.grey
		},
		transition: 'all 0.3s ease'
	},
	accordionStyleCollapsed: {
		margin: 0,
		padding: 0
	},

	accordionLabelContainer: {
		display: 'flex',
		width: '100% !important',
		transition: 'all 0.3s ease',
		height: '4.8rem !important',
		overflow: 'hidden',
		alignItems: 'center !important',
		padding: '.4rem'
	},
	accordionLabelContainerCollapsed: {
		width: 'fit-content !important'
	},
	accordionLabelIconContainer: {
		flex: 1,
		transition: 'all 0.3s ease',
		width: 'fit-content',
		alignItems: 'center',
		paddingTop: '1rem'
	},
	accordionLabelIconContainerCollapsed: {
		margin: 0,
		padding: '1rem 0 0 0',
		svg: {
			margin: 0,
			marginLeft: '1rem',
			paddingLeft: '2rem !important',
			paddingBottom: '3rem'
		}
	},
	accordionLabelNameExpanded: {
		flex: 9,
		overflow: 'hidden',
		animation: '$accordionNameAnimation 0.4s ease forwards',
		transition: 'all 0.3s ease',
		visibility: 'visible'
	},
	'@keyframes accordionNameAnimation': {
		'0%': {
			opacity: 0,
			width: '0rem'
		},
		'50%': {
			opacity: 0.5
		},
		'100%': {
			opacity: 1,
			width: '100% !important',
			paddingLeft: '2rem'
		}
	},
	accordionLabelNameCollapsed: {
		flex: 9,
		overflow: 'hidden',
		paddingLeft: '0 !important',
		width: '0px !important',
		transition: 'all 2s ease',
		visibility: 'hidden'
	},

	accordionDetails: {
		transition: 'all 0.3s ease'
	},
	accordionDetailsCollapsed: {
		padding: '0 !important',
		textAlign: 'center',
		margin: '0 !important',
		'& div': {
			paddingLeft: 0,
			paddingTop: '.5rem'
		}
	},
	acordionExpandIconCollapsed: {
		visibility: 'hidden',
		pointerEvents: 'none'
	},
	chipStyle: {
		position: 'absolute',
		right: '5rem',
		backgroundColor: 'white !important'
	}
}));
